import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { ChangePasswordDialogComponent } from './components/dialog/change-password-dialog/change-password-dialog.component';
import { UserFormComponent } from './components/embedded/user-form/user-form.component';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ChangePasswordFormComponent } from './components/embedded/change-password-form/change-password-form.component';
import { SharedModule } from '../shared/shared.module';
import { ResetPasswordDialogComponent } from './components/dialog/reset-password-dialog/reset-password-dialog.component';
import { CompletePasswordResetComponent } from './components/main/complete-password-reset/complete-password-reset.component';



@NgModule({
  declarations: [
    UserFormComponent,
    ChangePasswordDialogComponent,
    ChangePasswordFormComponent,
    ResetPasswordDialogComponent,
    CompletePasswordResetComponent
  ],
  imports: [
    CommonModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    SharedModule
  ],
  exports: [
    UserFormComponent
  ]
})
export class UserModule { }
